import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getCurrentAdmin, loginAdmin } from '../services/api';
import './System.css';

function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    async function redirectAuthenticatedAdmin() {
      try {
        await getCurrentAdmin();
        navigate('/admin/financeiro', { replace: true });
      } catch (err) {
        // Sem sessão ativa; mantém a tela de login.
      }
    }

    redirectAuthenticatedAdmin();
  }, [navigate]);

  function updateField(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      await loginAdmin(form);
      navigate('/admin/financeiro');
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main className="system-page compact">
      <section className="system-shell login-shell">
        <header className="system-header">
          <span className="eyebrow">Área Bliss</span>
          <h1>Entrar</h1>
          <p>Acesse para controlar entradas, saídas e pendências financeiras do mês.</p>
        </header>

        <form className="quote-form" onSubmit={handleSubmit}>
          <label>
            Email
            <input name="email" type="email" value={form.email} onChange={updateField} required />
          </label>

          <label>
            Senha
            <input name="password" type="password" value={form.password} onChange={updateField} required />
          </label>

          {error && <p className="form-alert error">{error}</p>}

          <div className="form-actions">
            <Link to="/" className="secondary-action">
              Voltar
            </Link>
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Entrando...' : 'Acessar'}
            </button>
          </div>
        </form>
      </section>
    </main>
  );
}

export default AdminLogin;
